import React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import ReactPlayer from "react-player";
import TextLoop from "react-text-loop";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import "../../../assets/css/app.css";

import { Emphasize } from "../../styles";
import FacebookIcon from "../../../assets/images/icon_facebook.webp";
import InstagramIcon from "../../../assets/images/icon_instagram.webp";
import LinkedInIcon from "../../../assets/images/icon_linkedin.webp";
import MyNewsDeskIcon from "../../../assets/images/icon_mynewsdesk.webp";
import TwitterIcon from "../../../assets/images/icon_twitter.webp";
import YoutubeIcon from "../../../assets/images/icon_youtube.webp";

const Tinder = (props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <>
      <AppBar
        position="sticky"
        sx={{
          height: "80px",
          backgroundColor: "#ffffff",
          color: "rgb(78, 116, 162)",
          boxShadow: "rgba(78, 116, 162, 0.2) 0px 2px 4px -1px, rgba(78, 116, 162, 0.14) 0px 4px 5px 0px, rgba(78, 116, 162, 0.12) 0px 1px 10px 0px",
        }}
      >
        <Container
          maxWidth="lg"
          sx={{
            height: "100%",
            display: "flex",
            alignItems: "center",
            padding: "10px 0",
          }}
        >
          <TextLoop>
            <span>
              <Typography
                sx={{
                  letterSpacing: "4px",
                  fontWeight: 500,
                }}
              >
                ARE YOU AND YOUR PARTNER COMPATIBLE?
              </Typography>
            </span>
            <span>
              <Typography
                sx={{
                  letterSpacing: "4px",
                  fontWeight: 500,
                  fontSize: "32px",
                  fontFamily: "vladimir",
                }}
              >
                HealthyRelationships.coach
              </Typography>
            </span>
            <span>
              <Typography
                sx={{
                  letterSpacing: "4px",
                  fontWeight: 500,
                }}
              >
                POWERED BY CLIFTONSTRENGTHS
              </Typography>
            </span>
          </TextLoop>
        </Container>
      </AppBar>
      <Container
        maxWidth="lg"
        sx={{
          marginTop: "30px",
          textAlign: "justify",
        }}
      >
        <Box sx={{ width: "100%", padding: "6px 0" }}>
          <Typography>
            So, you've met someone on <Emphasize>Tinder</Emphasize>.
            Or on a <Emphasize>blind date</Emphasize>.
            Or at <Emphasize>Lunch Actually</Emphasize>.
            Assuming you're looking for a <Emphasize>serious relationship</Emphasize>,
            how can you quickly tell whether you and your new partner are <Emphasize>compatible</Emphasize>?
          </Typography>
        </Box>
        <Box sx={{ width: "100%", padding: "6px 0" }}>
          <Typography>
            Opposites might be said to attract, but common values, common hobbies, and a common purpose, are what really makes long-term romantic relationships work.
            Identifying and crystallising areas of friction is the first step to resolving them.
          </Typography>
        </Box>
        <Box sx={{ width: "100%", padding: "6px 0" }}>
          <Typography>
            <Emphasize>There are two ways to get to know each other well:</Emphasize>
            <ol style={{ marginTop: "12px"}}>
              <li>
                Go on a dozen dates, and after about six months discover that
                the other person has traits and quirks that actually really annoy you.
              </li>
              <li>
                Take the assessment at <span>
                <Link
                  href="https://healthyrelationships.coach/"
                  target="_blank"
                  rel="noopener"
                >HealthyRelationships.coach</Link>
                </span>.
                This quickly shows you where you and your new partner have common ground
                and complementary personality traits, but also contrasts and zones for potential conflict.
              </li>
            </ol>
          </Typography>
        </Box>
        <Box sx={{ float: "right", marginLeft: "24px" }}>
          <ReactPlayer
            url="https://player.vimeo.com/showcase/9530211"
            controls={true}
            class="react-player"
          />
        </Box>
        <Box
          sx={{
            width: "100%",
            padding: "6px 0",
          }}
        >
          <Typography>
            For example, one of you might prefer to spend lots of quality time together, while the other prefers an active social life.
          </Typography>
          <Typography sx={{ marginTop: "12px" }}>
            One of you might prefer to think things through deeply, while the other leaps into action.
          </Typography>
          <Typography sx={{ marginTop: "12px" }}>
            One of you might be future focused while the other prefers to live in the moment, or even spends much time reflecting on the past.
          </Typography>
          <Typography sx={{ marginTop: "12px" }}>
            One of you might make detailed plans while the other prefers to go with the flow.
          </Typography>
          <Typography sx={{ marginTop: "12px" }}>
            One of you might be trusting and gregarious, while the other is cautious and reserved.
          </Typography>
          <Typography sx={{ marginTop: "12px" }}>
            Better to find this out at the start of your relationship than later once you have already invested lots of time and possibly money in dating, or even made a serious commitment.
          </Typography>
        </Box>
        <Box sx={{ width: "100%", padding: "12px 0" }}>
          <Typography>
            Visit <span>
            <Link
              href="https://healthyrelationships.coach/"
              target="_blank"
              rel="noopener"
            >HealthyRelationships.coach</Link>
            </span> to get your personalised couple report now, and discover whether you're truly made for each other.
          </Typography>
        </Box>
      </Container>
      <Box
        sx={{
          width: "100%",
          marginTop: "auto",
          backgroundColor: "rgb(61, 61, 61)",
        }}
      >
        <Container
          maxWidth="lg"
          sx={{
            color: "#ffffff",
            display: isMobile ? "block" : "flex",
            gap: "64px",
          }}
        >
          <Box
              sx={{
                flex: 1,
                paddingTop: "30px",
                paddingBottom: "10px",
              }}
          >
            <Box sx={{ marginBottom: "20px" }}>
              <Typography variant="h6">OUR OFFICES</Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
              }}
            >
              <Box sx={{ marginRight: "64px" }}>
                <Typography variant="body1">SINGAPORE</Typography>
                <Typography variant="body1">138 Robinson Road</Typography>
                <Typography variant="body1">#21-02 Oxley Tower Lobby 1</Typography>
                <Typography variant="body1">Singapore 068906</Typography>
              </Box>
              <Box>
                <Typography variant="body1">MALAYSIA</Typography>
                <Typography variant="body1">800 Jalan Sentul</Typography>
                <Typography variant="body1">D6 @ Sentul East</Typography>
                <Typography variant="body1">Unit 1-9</Typography>
                <Typography variant="body1">51000 Kuala Lumpur</Typography>
                <Typography variant="body1">Malaysia</Typography>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              flex: 0,
              paddingTop: "30px",
              paddingBottom: "10px",
            }}
          >
            <Box sx={{ marginBottom: "20px" }}>
              <Typography variant="h6">FOLLOW US</Typography>
            </Box>
            <Box sx={{ display: "flex", gap: "24px" }}>
              <Link
                href="http://www.mynewsdesk.com/sg/hong-bao-media"
                target="_blank"
                rel="noopener"
              >
                <img src={MyNewsDeskIcon} alt="MyNewsDesk" />
              </Link>
              <Link
                href="https://www.linkedin.com/company/hongbaomedia"
                target="_blank"
                rel="noopener"
              >
                <img src={LinkedInIcon} alt="LinkedIn" />
              </Link>
              <Link
                href="https://twitter.com/HongBaoMedia"
                target="_blank"
                rel="noopener"
              >
                <img src={TwitterIcon} alt="Twitter" />
              </Link>
              <Link
                href="https://www.facebook.com/hongbaomedia/"
                target="_blank"
                rel="noopener"
              >
                <img src={FacebookIcon} alt="Facebook" />
              </Link>
              <Link
                href="https://www.youtube.com/user/hongbaomedia"
                target="_blank"
                rel="noopener"
              >
                <img src={YoutubeIcon} alt="Youtube" />
              </Link>
              <Link
                href="https://instagram.com/hongbaomedia"
                target="_blank"
                rel="noopener"
              >
                <img src={InstagramIcon} alt="Instagram" />
              </Link>
            </Box>
          </Box>
        </Container>
      </Box>
    </>
  );
}

export default Tinder;
